import * as mediaDevices from "./media-devices"

/** @returns `true` if user has granted camera permissions, `false` otherwise */
export const requestCameraPermission = async () => {
  const isAlreadyGranted =
    "permissions" in navigator
      ? await navigator.permissions
          .query({ name: "camera" as PermissionName })
          .then(({ state }) => state === "granted")
          .catch(() => false)
      : false

  if (isAlreadyGranted) return true

  if (typeof navigator.mediaDevices === "undefined") return false

  return await mediaDevices
    .getUserMedia({ video: true })
    .then((stream) => stream.getTracks().forEach((track) => track.stop()))
    .then(() => true)
    .catch(() => false)
}
